import { mapImage } from "~/assets/assets";
import HubbleImage from "~/widgets/hubble_image";

interface NearbyStoreMapProps {
  storeLocatorUrl: string;
}

/**
 * Nearby store map section with placeholder
 */
export function NearbyStoreMap(props: NearbyStoreMapProps) {
  const handleClick = () => {
    window.open(props.storeLocatorUrl, "_blank");
  };

  return (
    <div class="flex flex-col overflow-hidden rounded-[12px] border border-stroke-1 stroke-text-normal-primary">
      <HubbleImage
        src={mapImage}
        alt="Map"
        class="aspect-[352/143] h-full w-full object-cover"
      />

      {/* Find nearby store action */}
      <button
        onClick={handleClick}
        class="shadow-sm flex h-11 items-center gap-2 bg-background-normal-primary px-3 py-2 hover:bg-background-normal-secondary"
      >
        <MapPinIcon />
        <span class="flex-1 text-left text-para-3-medium text-text-normal-primary">
          Find nearby store
        </span>
        <ChevronRightIcon />
      </button>
    </div>
  );
}

function MapIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-text-normal-tertiary"
      />
      <circle
        cx="12"
        cy="10"
        r="3"
        stroke="currentColor"
        stroke-width="2"
        class="text-text-normal-tertiary"
      />
    </svg>
  );
}

function MapPinIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.0492 15H17.5582C18.4192 15 19.1832 15.551 19.4552 16.368L20.1222 18.368C20.5542 19.663 19.5902 21 18.2252 21H5.77522C4.41022 21 3.44622 19.663 3.87822 18.368L4.54522 16.368C4.81622 15.551 5.58122 15 6.44222 15H8.95222"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 18C12 18 6 13.208 6 8.833C6 5.612 8.686 3 12 3C15.314 3 18 5.612 18 8.833C18 13.208 12 18 12 18Z"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4142 7.58579C14.1953 8.36684 14.1953 9.63317 13.4142 10.4142C12.6332 11.1953 11.3668 11.1953 10.5858 10.4142C9.80474 9.63317 9.80474 8.36684 10.5858 7.58579C11.3668 6.80474 12.6332 6.80474 13.4142 7.58579"
        class="stroke-inherit"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15l5-5-5-5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-text-normal-tertiary"
      />
    </svg>
  );
}
